import {
  IErrorApiResponse,
  IFormConfigurationContext,
  IOptionItem,
  ISuccessApiResponse,
} from '@wyz/types';
import { UseQueryResult } from '@wyz/utils';
import { createContext } from 'react';
import {
  IBrand,
  ISeasonOptionItem,
  ISupplierTypeOptionItem,
  IVehicleTypeGroupsOptionItem,
} from '~/common/types';
import { ISeason } from '~/purchase/types';
import { IActiveVehicleTypeGroupReturnType } from '~/purchase/hooks';

export type IFormContext = {
  mode: IFormConfigurationContext['mode'];
  seasons: { optionItems: Array<ISeasonOptionItem> } & UseQueryResult<
    ISuccessApiResponse<ISeason[]>,
    IErrorApiResponse
  >;
  vehicleTypeGroups: IActiveVehicleTypeGroupReturnType & {
    optionItems: Array<IVehicleTypeGroupsOptionItem>;
  };

  pricingConfigurationTypes: { optionItems: Array<IOptionItem> };
  supplierTypes: Array<ISupplierTypeOptionItem>;
  brands: {
    all: Array<IBrand>;
  };
};
export const FormContext = createContext<IFormContext | undefined>(undefined);
